/**
 * Constructor of element customer name input field.
 * Uses for creation and display the form where customer can input his name.
 * This name will be used in the chat transcript for string of customer name.
 * @constructor
 */
com.inq.ui.CustomerNameInputField = function(messageId) {
	this._initialized = false;
	this._closed = false;
	this._autofocus = false;
	this._disableEventListener = false;
	this._messageId = messageId;
	this._container = Application.application.getMxmlItem(this.CONTAINER_ID);

	var savedInstance = this._container ? this._container.customerNameInput : null;
	if (!savedInstance) {
		this._input = Application.application.getMxmlItem(this.INPUT_FIELD_ID);
		this._sendButton = Application.application.getMxmlItem(this.SEND_BUTTON_ID);
		this.init();
	} else if (!savedInstance._closed) {
		return savedInstance;
	}
};

com.inq.ui.CustomerNameInputField.prototype.init = function() {
	/** @type {boolean} */
	var isCustomerNameUpdated = com.inq.flash.client.control.FlashVars.isCustomerNameUpdated();
	/* Customer name can be set only one time.
	 * First of all we should check that customer name is not specified earlier,
	 * because if it is already specified then customer name input field is not needed
	 * and we don't need to initialize it and display.
	 */
	if (!isCustomerNameUpdated && this._container && this._input && this._sendButton) {
		this._container.customerNameInput = this;
		this.submit = this.submit.bind(this);
		this._sendButton.addEventListener(com.inq.events.MouseEvent.CLICK, this.submit);
		this.submitOnEnter = this.submitOnEnter.bind(this);
        this._input.addEventListener(com.inq.events.KeyboardEvent.KEY_UP, this.submitOnEnter);
		this._autofocus = this._input.getStyle("autofocus") == "true";
		if (this._autofocus) {
			this.onBlur = this.onBlur.bind(this);
			this._input.addEventListener(com.inq.events.FocusEvent.FOCUS_OUT, this.onBlur);
		}
		if(this._input._input) {
			var _ctfm = com.inq.flash.client.chatskins.ChatTextFocusMonitor;
			this._input._input.onfocus =  _ctfm.onFocus;
			this._input._input.onblur = _ctfm.onBlur;
		}
		this._initialized = true;
	}
};

com.inq.ui.CustomerNameInputField.prototype.show = function() {
	if (this._initialized && !this._closed) {
		if (!this._container.getVisible()) {
			this._container.setVisible(true);
		}
		/** @type {Window} */
		var appContext = Application.application.getPanelWindow();
		var messageContainer = com.inq.ui.Container._getElementById(this._messageId,appContext.document);
		if (messageContainer && this._container._div.parentNode != messageContainer) {
			messageContainer.appendChild(this._container._div);
		}
	}
};

/**
 * setUpFocus - set up focus properly feature is active, depends on device type
 * @public
 * @see com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField
 * @return {void}
 */
com.inq.ui.CustomerNameInputField.prototype.setUpFocus = function () {
	if (this._autofocus && !this._shown_first_time) {
		if (com.inq.utils.Capabilities.isMobile()) {
			/*
			 * RTDEV-15481 we must focus on the button for mobile and on the text area for desktop
			 * we need to flag initialFocusClaimedBy so that the chat send button doesn't overtake the focus
			 */
			this.setUpAriaMessages();
			this._sendButton._img.focus();
			com.inq.flash.client.chatskins.SkinControl.initialFocusClaimedBy = this._sendButton._img;
		} else {
			this._input.setFocus();
			com.inq.flash.client.chatskins.SkinControl.initialFocusClaimedBy = this._input;
		}
	}
	this._shown_first_time = true;
};
/**
 * setUpAriaMessages
 * @private
 * set up required aria message,
 * @see AriaMsg.addAriaMsg
 * adds title for send button for iPhone.
 * @return {void}
 */
com.inq.ui.CustomerNameInputField.prototype.setUpAriaMessages = function () {
	com.inq.aria.AriaMsg.addAriaMsg("Double tap to enter your name.");
	var appContext = Application.application.getPanelWindow();
	var messageContainer = com.inq.ui.Container._getElementById(this._messageId,appContext.document);
	try {
		/**
		 * RTFEV-16172
		 * The following line only applies to iPhone.  It causes screen talkback to say the
		 * opener script and "Double tap to enter your name" twice for Android phone. Not sure why but
		 * according to Justin Shanks, it is needed for iPhone.
		 */
		if (com.inq.utils.Capabilities.isIphone()) {
			this._sendButton._img.title = messageContainer.parentNode.children[0].innerText + messageContainer.parentNode.children[1].innerText + '. Double tap to enter your name. ' + this._sendButton._img.title;
		}
	} catch(e) {}
};

com.inq.ui.CustomerNameInputField.prototype.hide = function() {
	if (this._initialized && !this._closed && this._container.getVisible()) {
		this._container.setVisible(false);
		this._container._div.parentNode.removeChild(this._container._div);
	}
};

/*
 * Listener that submits the inline form when enter key is pressed
 * 
 * @param ke javascript keyboard event
 * 
 * @return bool true
 */
com.inq.ui.CustomerNameInputField.prototype.submitOnEnter = function(ke) {
  if (ke && ke.keyCode == com.inq.ui.Keyboard.ENTER) {
      this.submit();
  }
  return true;
};

com.inq.ui.CustomerNameInputField.prototype.submit = function() {
	var customerName = this._input.getText();
	if (customerName != "") {
		com.inq.flash.client.control.FlashVars.setCustomerName(customerName, true);
		Application.application.applicationController.updateUsername();
		var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
		if (txtInput) {
			txtInput.setFocus(true);
		}
		this.cancel();
	  } else {
	    this._input._input.focus();
	  }
};

com.inq.ui.CustomerNameInputField.prototype.cancel = function() {
	this.hide();
	this._sendButton.removeEventListener(com.inq.events.MouseEvent.CLICK, this.submit);
	this._input.removeEventListener(com.inq.events.KeyboardEvent.KEY_UP, this.submitOnEnter);
	this._input.removeEventListener(com.inq.events.FocusEvent.FOCUS_OUT, this.onBlur);
	if(this._input._input) {
		this._input._input.onfocus =  null;
		this._input._input.onblur = null;

	}
	this._closed = true;
	this._container = null;
	this._input = null;
	this._sendButton = null;
};

com.inq.ui.CustomerNameInputField.prototype.onBlur = function() {
	if (!this._disableEventListener) {
		this._autofocus = false;
	}
};

com.inq.ui.CustomerNameInputField.prototype.disableEventListener = function() {
	this._disableEventListener = true;
};

com.inq.ui.CustomerNameInputField.prototype.enableEventListener = function() {
	this._disableEventListener = false;
};

/**
 *
 * @param message
 * @returns {boolean}
 */
com.inq.ui.CustomerNameInputField.isContainsInsertionMarker = function(message) {
	return message.indexOf(com.inq.ui.CustomerNameInputField.INSERTION_MARKER) != -1;
};

/**
 *
 * @param message
 * @returns {string}
 */
com.inq.ui.CustomerNameInputField.removeInsertionMarker = function(message) {
	var result = message.replace(com.inq.ui.CustomerNameInputField.INSERTION_MARKER, "");
	// Check the message after replace operation.
	// Add "\n" symbol if message is empty - because an empty messages are not shown on CI.
	return result.length != 0 ? result : "\n";
};

/** @type {string} */
com.inq.ui.CustomerNameInputField.prototype.CONTAINER_ID = "customerNameInput";
/** @type {string} */
com.inq.ui.CustomerNameInputField.prototype.INPUT_FIELD_ID = "customerNameInputField";
/** @type {string} */
com.inq.ui.CustomerNameInputField.prototype.SEND_BUTTON_ID = "customerNameSendButton";
/** @type {string} */
com.inq.ui.CustomerNameInputField.INSERTION_MARKER = "{{CUSTOMER_NAME_INPUT}}";
